module.exports = __webpack_public_path__ + "5517aae1bf84cc33bd9e0b94d8914d3e.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/dummy_image_chicken.png
// module id = 54
// module chunks = 0